
/* injects from baggage-loader */

import Config from "@skin_config";
import { broadcast, broadcastChannels } from "@app/dev/helpers/broadcast";
import {mathCuttingFunction} from "../filters";
import Zergling from "@app/dev/helpers/zergling";
import { getRoundingMethod } from './roundingMethod';
import config from "../../../BettingTerminal.App/skins/newbettingterminal-bet-one.betconstruct.com/config";

let roundMethod = _.noop;

export const setOddConverterPartnerConfig = partner => {
    roundMethod = getRoundingMethod(partner.price_round_method);
};

/**
 * Odd converter
 * returns a function to convert decimal odds to corresponding format
 * Usage:
 * OddConverter(odd, format)
 * e.g.  var coefficient = OddConverter(1.01, "fractional")
 */
 const OddConverter = (function (Config) {
    let ladder = null;
    let ladderKeys = null;

    async function socketStateChange(e) {
        if (e.detail?.connected) {
            const response = await Zergling.get({}, "get_permissible_odds");
            if (response.details) {
                convertLadddersFromSwarm(response);
                broadcast.removeEventListener(broadcastChannels.SocketStateChange, socketStateChange);
            }
        }
    }

    broadcast.addEventListener(broadcastChannels.SocketStateChange, socketStateChange);

    function convertLadddersFromSwarm(response) {
        ladder = {};

        response.details.forEach(item => {
            ladder[item.Price] = `${item.Numerator}/${item.Denominator}`;
        });

        ladderKeys = Object.keys(ladder).sort(function (a, b) {
            return parseFloat(a) - parseFloat(b);
        });
    }
    /**
     * Recursively finds the biggest decimal odd that is smaller than num
     * @param startIndex search start index
     * @param endIndex search end index
     * @param num decimal odd value to compare with
     */
    function findNearestLadderKey(startIndex, endIndex, num) {
        var middleIndex = startIndex + Math.ceil((endIndex - startIndex) / 2);
        if ((middleIndex === 0 && ladderKeys[middleIndex] > num) || (middleIndex === ladderKeys.length - 1 && ladderKeys[middleIndex] < num) || (ladderKeys[middleIndex] < num && num < ladderKeys[middleIndex + 1])) {
            return ladderKeys[middleIndex];
        } else {
            if (ladderKeys[middleIndex] < num) {
                return findNearestLadderKey(middleIndex, endIndex, num);
            } else {
                return findNearestLadderKey(startIndex, middleIndex - 1, num);
            }
        }
    }

    function dec2fracFromLadder(dec) {
        var val;
        if (ladder[dec]) {
            return ladder[dec];
        } else {
            val = findNearestLadderKey(0, ladderKeys.length - 1, dec);
            return ladder[val];
        }
    }

    /**
     * Recursively converts odd to fractional format
     * @param {string} decVal odd value from swarm(decimal)
     * @returns {string} converted odd
     */
    function dec2frac(decVal) {
        var Znxt;
        var Dnxt;
        var Nnxt;
        function recCalc(Zcur, Dcur, Dprev) {
            Dcur = Dcur !== undefined ? Dcur : 1;
            Dprev = Dprev !== undefined ? Dprev : 0;
            Znxt = 1 / (Zcur - parseInt(Zcur, 10));
            Dnxt = Dcur * parseInt(Znxt, 10) + Dprev;
            Nnxt = Math.round(decVal * Dnxt);

            return (Nnxt / Dnxt === decVal) ? Nnxt.toString() + "/" + Dnxt.toString() : recCalc(Znxt, Dnxt, Dcur);
        }

        // Use this casting method because of JS number bug for example "2.2 - 1 = 1.1999(9)"
        if (decVal !== parseInt(decVal, 10)) {
            decVal = parseFloat((parseInt(decVal, 10) - 1).toString() + "." + String(decVal).split(".")[1]);
        } else {
            decVal = decVal - 1;
        }

        return decVal % 1 === 0 ? String(decVal) + '/1' : String(recCalc(decVal));

    }

    /**
     * possible formats.  the first one will be used as default if no valid format is found in config
     * @type {Array}
     */
    var possibleFormats = ['decimal', 'fractional', 'american', 'hongkong', 'malay', 'indo'];

    /**
     * Converts odd to specified format
     * @param {string} value odd value from swarm(decimal)
     * @param {string} format destination format
     * @returns {string} converted odd
     */

    const decimalZeroFill = fValue => (
        Config.main.coefficientsDecimalZeroFill
            ? fValue.toFixed(Config.main.roundDecimalCoefficients)
            : fValue
    );
    
    function convert(value, format, type) {
        // TODO: refactor
        if (format === 'fractional' && Config.main.useLadderForFractionalFormat && type === 'fictional' && value !== undefined) // use it to calculate express odds as you see on bet365 :)
            return Math.round(parseFloat(value - 1) * 100 || 0) / 100 + '/1';

        var fValue = parseFloat(value);
        var iValue = parseInt(value, 10);
        var rValue = (value !== undefined && value !== '') ? Math.round(fValue * 100 || 0) / 100 : value;
        switch (format) {
            case 'decimal':
                // console.log((iValue !== fValue && value.toString().split('.')[1] && value.toString().split('.')[1].length > 2), 'condition')

                if (value === undefined || value === '' || Config.main.enableCoeficenFullValueView) {
                    return value;
                }
                // if (Config.main.oddDecimalFormat2Digits) {
                //     return (mathCuttingFunction(fValue * 10 * 10) / 100).toFixed(2); // 10 * 10 because javascript have bug 8.2 * 100 = 819.9999999999999
                // }

                const roundingNeeded = iValue !== fValue && value.toString().split('.')[1] && value.toString().split('.')[1].length > Config.main.roundDecimalCoefficients;
                return roundingNeeded ? roundMethod(value, Config.main.roundDecimalCoefficients) : decimalZeroFill(fValue);
            case 'fractional':
                return value ? (Config.main.useLadderForFractionalFormat ? dec2fracFromLadder(fValue) : dec2frac(rValue)) : value;
            case 'american':
                return value ? rValue >= 2 ? '+' + Math.round(100 * (rValue - 1)) : rValue !== 1 ? Math.round(-100 / (rValue - 1)) : '-' : rValue;
            case 'hongkong': {
                let hValue;
                if (value !== undefined && value !== '') {
                    if (iValue !== fValue && value.toString().split('.')[1].length > 2) {
                        hValue = Math.round((value - 1) * Math.pow(10, Config.main.roundDecimalCoefficients)) / Math.pow(10, Config.main.roundDecimalCoefficients);
                    } else {
                        hValue = (fValue - 1).toFixed(2);
                    }
                } else {
                    hValue = value;
                }
                if (Config.main.oddDecimalFormat2Digits) {
                    hValue = (mathCuttingFunction(hValue * 10 * 10) / 100).toFixed(2);
                }
                return hValue;
            }
            case 'malay':
                if (fValue === 2) {
                    return '1.000';
                } else if (fValue > 2) {
                    return (Math.round(((1 / (1 - fValue)).toFixed(Config.main.roundDecimalCoefficients + 1)) * Math.pow(10, Config.main.roundDecimalCoefficients)) / Math.pow(10, Config.main.roundDecimalCoefficients)).toFixed(Config.main.roundDecimalCoefficients);
                } else {
                    return (fValue - 1).toFixed(Config.main.roundDecimalCoefficients);
                }
            case 'indo':
                if (fValue === 2) {
                    return '1.000';
                } else if (fValue > 2) {
                    return (fValue - 1).toFixed(Config.main.roundDecimalCoefficients);
                } else {
                    return (Math.round(((1 / (1 - fValue)).toFixed(Config.main.roundDecimalCoefficients + 1)) * Math.pow(10, Config.main.roundDecimalCoefficients)) / Math.pow(10, Config.main.roundDecimalCoefficients)).toFixed(Config.main.roundDecimalCoefficients);
                }
            default:
                return rValue;
        }
    }

    const convertMemo = _.memoize(convert, (...args) => args.join('_'));

    return function (value, format, type = null, displayKey, doesNeedOriginal) {
        if (!ladder || !ladderKeys) return null;
        format = format || Config.env.oddsFormat;
        if (value === null || value === undefined || isNaN(value)) {
            return value;
        }
        if (value === 1) {
            return null;
        }
        if (Config.main.specialOddFormat && Config.main.specialOddFormat[format]) {
            if (!doesNeedOriginal) {
                format = Config.main.specialOddFormat[format].displayKey[displayKey] || Config.main.specialOddFormat[format].default;
            } else if (Config.main.specialOddFormat[format].originalOddType) {
                format = Config.main.specialOddFormat[format].originalOddType;
            }
        }

        if (!possibleFormats.includes(format))  //select default format if current one is invalid
            format = possibleFormats[0];

        return convertMemo(value, format, type);
    };

})(Config);

export default OddConverter;